import { Grid } from '@mui/material';
import React from 'react';
import TestCyclesTabContentComponent from '../../components/project-dashboard/test-cycles/TestCyclesTabContent';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';

const TestCyclesPage = () => {
  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TestCyclesTabContentComponent />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default TestCyclesPage;
